import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Lang = 'fr' | 'ar';

interface LangStore {
  lang: Lang;
  setLang: (lang: Lang) => void;
}

function applyLang(lang: Lang) {
  document.documentElement.lang = lang;
  document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
}

export const useLangStore = create<LangStore>()(
  persist(
    (set) => ({
      lang: 'fr',
      setLang: (lang) => {
        applyLang(lang);
        set({ lang });
      },
    }),
    {
      name: 'idanroh-lang',
      onRehydrateStorage: () => (state) => {
        if (state) applyLang(state.lang);
      },
    }
  )
);
